import { compose } from 'ramda';

import { saveReturnPath } from '#src/store/location/actions';

import { anonymousOnly } from '../guards';

export const path = '/full-signup';
export const component = 'FullSignup';

export const thunk = () => (dispatch, getState) => {
  if (anonymousOnly(dispatch, getState)) return;
  compose(dispatch, saveReturnPath)();
};
